import { render, staticRenderFns } from "./ProductsComponent.vue?vue&type=template&id=439cfa0d&scoped=true&"
import script from "./ProductsComponent.vue?vue&type=script&lang=js&"
export * from "./ProductsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439cfa0d",
  null
  
)

export default component.exports